import { Component } from 'react';

import ContentOuterBound from './common/atoms/ContentOuterBound';
import ImageLeftAndTextRightMolecule from './common/molecules/ImageLeftAndTextRightMolecule';
import ContentSpacer from './common/atoms/ContentSpacer';

import * as InternalPropTypes from '../constants/internal-types';
import * as Breakpoints from '../constants/breakpoints';
import {
  TypeBackgroundColorTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';

const styles = {
  [Breakpoints.TabletDown.mq]: {
    paddingTop: '52px',
    paddingBottom: '52px',
  },
  [Breakpoints.DesktopUp.mq]: {
    paddingTop: '64px',
    paddingBottom: '64px',
  },
};

type ImageLeftAndTextRightComponentProps = {
  image?: InternalPropTypes.Image;
  bodyText?: InternalPropTypes.RichText;
  mainHeaderText?: InternalPropTypes.RichText;
  lightHeaderText?: InternalPropTypes.RichText;
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class ImageLeftAndTextRightComponent extends Component<ImageLeftAndTextRightComponentProps> {
  static defaultProps = {
    image: null,
    bodyText: null,
    mainHeaderText: null,
    lightHeaderText: null,
    backgroundColor: null,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const {
      image,
      mainHeaderText,
      lightHeaderText,
      bodyText,
      backgroundColor,
      seoWeight,
    } = this.props;

    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    return (
      <div
        css={[styles, addStyle]}
        className="image-left-and-text-right-component"
      >
        <ContentOuterBound>
          <ContentSpacer>
            <ImageLeftAndTextRightMolecule
              image={image}
              mainHeaderText={mainHeaderText}
              lightHeaderText={lightHeaderText}
              bodyText={bodyText}
              seoWeight={seoWeight}
            />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default ImageLeftAndTextRightComponent;
